module.exports = __webpack_public_path__ + "static/media/30OIOS2.8462be82.jpg";